import React, { createRef, useMemo, useState } from 'react';
import DashboardBox from '../components/DashboardBox';
import SearchBar from '../components/search/SearchBar';
import ApiTable from '../components/table/ApiTable';
import EditTeacherDialog from '../components/dialog/EditTeacherDialog';
import TeacherUtil from '../utils/TeacherUtil';
import { CircularProgress, Stack } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import OutlinedIconButton from '../components/button/OutlinedIconButton';
import { useUserInfo } from '../providers/UserProvider';
import { AUTHORIZED_SETTINGS_USER_ROLES } from '../constants/Roles';

const Teachers = () => {
  const { userInfo } = useUserInfo();
  const tableRef = createRef();
  const [teacherToEdit, setTeacherToEdit] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const filters = useMemo(
    () => ({
      search: searchTerm,
    }),
    [searchTerm],
  );
  const columns = useMemo(() => {
    return [
      {
        header: 'Naam',
        enableSortBy: true,
        sortField: 'fullName',
        Cell: ({ value }) => {
          return value.firstName + ' ' + value.lastName;
        },
      },
      {
        header: 'Aantal leerlingen',
        enableSortBy: true,
        sortField: 'numberOfStudents',
        Cell: ({ value }) => {
          return value.numberOfStudents || 0;
        },
      },
      {
        header: 'Laatste log-in',
        accessor: 'lastLogin',
        enableSortBy: true,
        sortField: 'lastLogin',
      },
      ...(userInfo.user.role in AUTHORIZED_SETTINGS_USER_ROLES
        ? [
            {
              header: 'Acties',
              Cell: ({ value }) => (
                <Stack direction="row">
                  <OutlinedIconButton onClick={() => setTeacherToEdit(value)}>
                    <EditIcon />
                  </OutlinedIconButton>
                </Stack>
              ),
            },
          ]
        : []),
    ];
  }, [userInfo.user.role]);

  return (
    <Stack>
      <DashboardBox>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing={1}>
            <p className="title">Overzicht</p>
            {loading && <CircularProgress size={16} />}
          </Stack>
          <SearchBar setSearchTerm={setSearchTerm} />
        </Stack>
        <ApiTable
          ref={tableRef}
          apiSource={TeacherUtil.getTeachers}
          columns={columns}
          defaultOrderBy="fullName"
          setLoading={setLoading}
          filters={filters}
        />
      </DashboardBox>
      {teacherToEdit !== null && (
        <EditTeacherDialog
          teacher={teacherToEdit}
          open={true}
          onClose={(reload = false) => {
            setTeacherToEdit(null);
            if (reload) {
              tableRef.current?.loadData();
            }
          }}
        />
      )}
    </Stack>
  );
};

export default Teachers;
